import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Header from '../common/Header'
import './ShopPaymentCoupon.css'

import CouponModal from './Modal/CouponModal'
import { useTranslation } from "react-i18next";

const ShopPaymentCoupon = () => {
  const { t } = useTranslation();

  const [couponInfo, setCouponInfo] = useState({})
  const [couponLoading, setCouponLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [availablePointsLoading, setAvailablePointsLoading] = useState(false)
  const [availablePoints, setAvailablePoints] = useState([])
  const [count, setCount] = useState(0);

  const modalClose = () => {
    setIsOpen(false)
  }

  const createQouponQr = (e) => {

    setErrorMessage('');
    const initialValue = e.target.innerHTML;
    e.target.innerHTML = t('common.loading');

    const point = e.target.value;
    setCouponLoading(true)

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/payment-show-coupon`, {
      method: 'POST',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
          point: point,
      })

    })
    .then(response => response.json())
    .then(data => {

      if (data.hasError) {
        setErrorMessage(data.message);

      } else {
        setCouponInfo(data.coupon_info);
        setIsOpen(true);

      }

      e.target.innerHTML = initialValue;
      setCouponLoading(false)

    })
    .catch(error => {
      e.target.innerHTML = initialValue;
      setCouponLoading(false);
      setErrorMessage(error.message);

    });


  }

  useEffect(()=>{
    setErrorMessage('');
    setAvailablePoints([]);
    setAvailablePointsLoading(true);

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/payment-available-points`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Content-Type': 'application/json'
      },
      credentials: 'include',


    })
    .then(response => response.json())
    .then(data => {

      if (data.hasError) {
        setErrorMessage(data.message);
      
      } else {
        console.log(data)
        setAvailablePoints(data.available_points);

      }

      setAvailablePointsLoading(false);
    })
    .catch(error => {
      setAvailablePointsLoading(false);

    });

  }, [count]);
  
  
  const refresh = () => {
    setCount(count+1);
  }

  return (
    <>
      <Header />
      { availablePointsLoading 
        ? <div className="shop-payment-coupon">{t('shop_payment_coupon.displaying')}</div>
        : <>
          <div className="shop-payment-coupon">
            <div className="shop-payment-coupon-contents_header">
              <div className="shop-payment-coupon-title">{t('shop_payment_coupon.title')}</div>
              <div className="">
                <button className="shop-payment-coupon-refresh_button" onClick={refresh}>{t('shop_payment_coupon.redisplay')}</button>
              </div>
            </div>
            {errorMessage !== '' && 
              <div className="shop-payment-coupon-error_message">{errorMessage}</div>
            }
              <div className="shop-payment-coupon-point_list">
                { availablePoints.map((row, index) => {
                    return (
                        <div key={index} className="point-list-item">
                            <img src="../img/balance.svg" alt="balance" /> {`${Intl.NumberFormat("ja-JP").format(row.point)}pt`}
                            <button className="point-list-item-button" disabled={ ( couponLoading ? 'disabled' : '' ) } 
                              onClick={createQouponQr} value={row.point}>{`${t('shop_payment_coupon.yen')}${Intl.NumberFormat("ja-JP").format(row.point)}`}</button>
                        </div>
                    )
                  })
                }
              </div>
            </div>
            <CouponModal isOpen={isOpen} onRequestClose={modalClose} couponInfo={couponInfo} />
          </>
        }
    </>
  )
}

export default ShopPaymentCoupon